export const useGetTimeForHistory = () => {
    const getTime = () => {
        let d = new Date();
        let hora = d.getHours();
        let minutos = d.getMinutes();
        if (hora < 10) hora = 0 + hora;
        if (minutos < 10) minutos = 0 + minutos;
        return (hora + ":" + minutos)
    }
    return { getTime }
}

